<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  
  <div class="prev">
    <a [routerLink]="['/programme', 'weekly-reports']"
      ><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-left']"></fa-icon></span
    ></a>
  </div>
  <h2>Achievements</h2>
  <div class="next">
    <a [routerLink]="['/programme', 'about']">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-right']"></fa-icon></span
    ></a>
  </div>
</nav>
<div class="content-container">
  <div class="row">
    <div class="col">
      <div class="card bg-light">
        <div class="card-body">
          <h2 class="card-title text-center card-title-sm">
            Programme Weekly Streak
          </h2>
          <div *ngIf="isLoading" class="text-center">
            <app-loading-spinner [inline]="true"></app-loading-spinner>
          </div>

          <div *ngIf="!isLoading">
            <div *ngIf="weeklyParticipationBadges.length === 0">
              <div class="card-text text-center">No badges yet - keep going</div>
            </div>

            <div
              *ngIf="weeklyParticipationBadges.length > 0"
              class="achievements"
            >
              <app-achievements-badge
                *ngFor="let achievement of weeklyParticipationBadges"
                [achievement]="achievement"
              ></app-achievements-badge>
            </div>

            <!--p class="card-text-sm">
              <strong>Next streak:</strong>
              {{ nextParticipationStreak }}
              Weeks
            </p-->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col mt-3">
      <tabset [justified]="true">
        <tab [active]="area === 'global' || area === 'moveWell'">
          <ng-template tabHeading> Move Well </ng-template>

          <div class="card bg-light mt-4" *ngFor="let area of moveWellAreas">
            <div class="card-body">
              <h2 class="card-title text-center">{{area.label}}</h2>
              <div *ngIf="isLoading" class="text-center">
                <app-loading-spinner [inline]="true"></app-loading-spinner>
              </div>

              <div *ngIf="!isLoading">
                <div *ngIf="!getByArea(area.id)">
                  <div class="card-text text-center">No badges yet - keep going</div>
                </div>

                <div
                  *ngIf="
                  getByArea(area.id)
                  "
                  class="achievements mt-3 mt-3"
                >
                  <app-achievements-badge
                    *ngFor="let achievement of getByArea(area.id)"
                    [achievement]="achievement"
                  ></app-achievements-badge>
                </div>
              </div>
            </div>
          </div>

        </tab>
        <tab [active]="area === 'modules'">
          <ng-template tabHeading> Modules </ng-template>

          <div class="card bg-light mt-4" *ngFor="let area of moduleAreas">
            <div class="card-body">
              <h2 class="card-title text-center">{{area.label}}</h2>
              <div *ngIf="isLoading" class="text-center">
                <app-loading-spinner [inline]="true"></app-loading-spinner>
              </div>

              <div *ngIf="!isLoading">
                <div *ngIf="getByArea(area.id).length == 0">
                  <div class="card-text text-center">No badges yet - keep going</div>
                </div>

                <div
                  *ngIf="
                  getByArea(area.id)
                  "
                  class="achievements mt-3 mt-3"
                >
                  <app-achievements-badge
                    *ngFor="let achievement of getByArea(area.id)"
                    [achievement]="achievement"
                  ></app-achievements-badge>
                </div>
              </div>
            </div>
          </div>

        </tab>
      </tabset>
    </div>
  </div>
</div>
